export default {
  title: 'Contáctenos',
  text1: '¿En qué podemos ayudar?',
  text2: '(El manejo de los datos será estrictamente confidencial)',
  phone: 'Teléfono: 2338-0206',
  email: 'E-mail: administracion@romanyroman.com',
  address: 'Dirección: 6ta. Avenida 0-60 Gran Centro Comercial Zona 4, Torre Profesional I, Oficina 911',
  request: {
    name: 'Nombre Completo',
    phone: 'Teléfono(opcional)',
    email: 'Correo Electrónico',
    service: 'Servicio Requerido',
    message: 'Mensaje',
  },
  services: [
    {title: 'Asesoría y Consultoría'},
    {title: 'Auditoría'},
    {title: 'Traducción Jurada'},
    {title: 'Seminarios'},
    {title: 'Reclutamiento'},
    {title: 'Outsourcing'},
    {title: 'Tecnología y Sistemas'},
    {title: 'Impuestos y Legal'},
  ]
}



// WEBPACK FOOTER //
// ./src/text/es/contact.js